import { MetaWrapper } from '@components/Meta'
import { useFeedbackListQuery } from '@graphql/queries/__generated__/feedback.generated'
import { useMarketplacesQuery } from '@graphql/queries/__generated__/marketplace.generated'
import React, { useEffect } from 'react'
import { useQueryParams } from 'use-query-params'
import useGlobalLoader from '../../../hooks/useGlobalLoader'
import FeedbackPage, { IFeedbackFormData } from './FeedbackPage'
import { feedbackParams } from './types'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { Ordering } from '../../../../generated/gqlTypes'

const PAGINATE_BY = 20

const FeedbackView = () => {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const [params, setParams] = useQueryParams(feedbackParams)
  const { setLoading } = useGlobalLoader()
  const marketplacesQuery = useMarketplacesQuery({
    variables: { first: 100 },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })
  const dataQuery = useFeedbackListQuery({
    variables: {
      limit: PAGINATE_BY,
      offset: ((params.page || 1) - 1) * PAGINATE_BY,
      scoreGt: params.score === 5 ? 3 : params.score === 3 ? 1 : 0,
      scoreLt: params.score === 3 ? 4 : params.score === 1 ? 2 : 6,
      marketplace: params.marketplace || null,
      sortBy: [{ timeCreated: Ordering.Desc }],
    },
    onError: error => {
      enqueueSnackbar(error.message, { variant: 'error' })
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  })

  useEffect(() => {
    setLoading(dataQuery.loading || marketplacesQuery.loading)
  }, [dataQuery.loading, marketplacesQuery.loading])

  const onSubmit = (values: IFeedbackFormData) => {
    setParams({ score: values.score || undefined, marketplace: values.marketplace || undefined, page: 1 }, 'replaceIn')
  }
  const feedbackQueryData = dataQuery.data || dataQuery.previousData
  return (
    <MetaWrapper titleDetails={t('metaTitle.feedback', 'Feedback')}>
      <FeedbackPage
        feedbacks={feedbackQueryData?.feedbackList}
        page={params.page || 1}
        paginateBy={PAGINATE_BY}
        changePage={page => setParams({ page }, 'replaceIn')}
        marketplaces={marketplacesQuery.data?.marketplaces.edges || []}
        onSubmit={onSubmit}
      />
    </MetaWrapper>
  )
}

export default FeedbackView
